import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-logo',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './logo.component.svg',
  host: {
    style: 'display: inline-flex;',
  },
})
export class LogoComponent {}
